<div class="cm-wrap">
    @if (data.loading) {
        <div class="cm-badge cm-badge--neutral">
            <mat-progress-spinner mode="indeterminate" diameter="44" strokeWidth="4">
            </mat-progress-spinner>
        </div>
    } @else {
        <div class="cm-badge" [ngClass]="'cm-badge--' + tipo()">
            <mat-icon class="cm-icon" [ngClass]="'cm-icon--' + tipo()">{{ icono() }}</mat-icon>
        </div>
    }

    @if (data.title) {
        <h1 class="cm-title">{{ data.title }}</h1>
    }

    <mat-dialog-content class="cm-content">
        <div class="cm-message" [innerHTML]="data.message"></div>
    </mat-dialog-content>

    @if (data.dismissBtn || data.acceptBtn) {
        <div class="cm-actions">
            @if (data.dismissBtn) {
                <button mat-stroked-button class="cm-btn" (click)="close(false)">
                    {{ data.dismissBtnText ?? 'Cancelar' }}
                </button>
            }
            @if (data.acceptBtn) {
                <button color="accent" mat-raised-button class="cm-btn" (click)="close(true)">
                    {{ data.acceptBtnText ?? 'Aceptar' }}
                </button>
            }
        </div>
    }
</div>
